import React from "react";
import { useBrand } from "@/lib/useBrand";

export default function Footer() {
  const { name } = useBrand();
  // Hide global footer inside the portal-embed iframe — the portal owns the chrome
  // and EmbedShell already renders its own compact disclaimer.
  if (typeof window !== "undefined" && window.location.pathname.startsWith("/embed")) {
    return null;
  }
  return (
    <footer className="border-t border-white/5 bg-[#070F1C] mt-16">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-8 space-y-3">
        <div className="flex flex-wrap items-center justify-between gap-3 text-xs text-[#808A9B] tracking-wide">
          <div>© {new Date().getFullYear()} {name}</div>
          <div className="flex gap-4">
            <a href="/privacy" className="hover:text-[#F5A623]">Privacy</a>
            <a href="/terms" className="hover:text-[#F5A623]">Terms</a>
            <a href="/data-deletion" className="hover:text-[#F5A623]">Data deletion</a>
          </div>
          <div className="uppercase tracking-[0.25em]">
            Inspired by the &quot;$100M Offers&quot; framework
          </div>
        </div>
        <p
          className="text-[11px] leading-relaxed text-[#808A9B] max-w-3xl"
          data-testid="legal-disclaimer-footer"
        >
          <strong className="text-[#888]">Disclaimer:</strong> This software
          is an independent tool and is not affiliated with, endorsed by, or
          associated with Alex Hormozi or Acquisition.com.
        </p>
      </div>
    </footer>
  );
}
